<template>
  <div class="attendanceSettings">
    <HearderTitle name="考勤设置" />
    <div class="tableBox">
      <div class="tool_bar">
        <el-form :inline="true">
          <el-form-item style="margin-left: -10pxl; float: right">
            <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="add()">新增规则</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table ref="refTable" header-cell-class-name="h_bg" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="ID号" width="80" align="center"> </el-table-column>
          <el-table-column prop="sname" label="类型" align="center"> </el-table-column>
          <el-table-column label="标记" align="center">
            <template slot-scope="scope">
              {{ scope.row.pbty === 2 ? '竞价排班' : '咨询排班' }}
            </template>
          </el-table-column>
          <el-table-column prop="st" label="起始时间" align="center"> </el-table-column>
          <el-table-column prop="et" label="结束时间" align="center"> </el-table-column>
          <el-table-column label="操作" align="center" width="198">
            <template slot-scope="scope">
              <div class="table_btns">
                <el-button size="mini" @click="show(scope.row)">编辑</el-button>
                <el-button size="mini" @click="del(scope.row.id)" class="warning">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog class="attendanceDialog" ref="attendanceDialog" :modal="false" :title="attendanceDialogTitle" @close="$refs['attendance'].resetFields()" destroy-on-close :visible.sync="attendanceDialog" width="435px">
      <el-form ref="attendance" :rules="rules" :model="attendanceData" label-width="90px">
        <el-form-item label="标注" prop="sname">
          <el-input type="text" v-model="attendanceData.sname"></el-input>
        </el-form-item>

        <el-form-item label="类型" prop="pbty">
          <el-select v-model="attendanceData.pbty" clearable>
            <el-option :value="2" label="竞价排班"></el-option>
            <el-option :value="3" label="咨询排班"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始时间" prop="st">
          <el-time-picker value-format="HH:mm:ss" v-model="attendanceData.st" prefix-icon=" " align="right"> </el-time-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="et">
          <el-time-picker value-format="HH:mm:ss" v-model="attendanceData.et" prefix-icon=" " align="right"> </el-time-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" plain class="searchBtn" @click="$refs['attendance'].resetFields()">取消</el-button>
          <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="seve()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { attendanceSettings, addRule, editRule, delRule } from '@/api/attendance.js'
  import HearderTitle from '@/components/HearderTitle'
  export default {
    name: 'attendanceSettings',
    data() {
      return {
        tableData: [],
        attendanceDialogTitle: '新增规则',
        attendanceDialog: false,
        attendanceData: {
          pbty: '',
          st: '',
          et: '',
          id: '',
          sname: '',
        },
        rules: {
          pbty: [{ required: true, message: '标记不能为空', trigger: 'blur' }],
          st: [{ required: true, message: '起始时间不能为空', trigger: 'blur' }],
          et: [{ required: true, message: '结束时间不能为空', trigger: 'blur' }],
          sname: [{ required: true, message: '类型不能为空', trigger: 'blur' }],
        },
      }
    },
    created() {
      this.attendanceSettingsList()
    },
    components: { HearderTitle },
    methods: {
      // 获取人员列表
      async attendanceSettingsList() {
        let { plist } = await attendanceSettings(this.queryInfo)
        this.tableData = plist
      },
      add() {
        this.attendanceDialogTitle = '新增规则'
        this.attendanceDialog = true
      },
      // 删除人员
      async del(id) {
        if (!id) return this.$message.error('请选择要删除的数据')
        const res = await this.$confirm('您确定删除该用户吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).catch((err) => err)
        if (res !== 'confirm') return this.$message.info('取消成功')
        let response = await delRule({ id })
        if (response.status !== 200) {
          this.$message.error('删除失败')
        } else {
          this.$message.success('删除成功')
          // 删除成功后刷新页面
          this.attendanceSettingsList()
        }
      },
      // 显示修改状态弹窗
      show(data) {
        this.attendanceDialogTitle = '修改规则'
        this.attendanceData.id = data.id
        this.attendanceData.pbty = data.pbty
        this.attendanceData.st = data.st
        this.attendanceData.et = data.et
        this.attendanceData.sname = data.sname
        this.attendanceDialog = true
      },
      async seve() {
        this.$refs['attendance'].validate(async (valid) => {
          if (!valid) return
          let res = {}
          let data = this.attendanceData
          if (this.attendanceData.id === '') {
            res = await addRule(data)
          } else {
            res = await editRule(data)
          }
          if (res.status !== 200) return this.$message.error('提交失败')
          this.$message.success('提交成功')
          this.$refs['attendance'].resetFields()
          this.attendanceDialog = false
          return this.attendanceSettingsList()
        })
      },
    },
  }
</script>

<style lang="less">
  .attendanceSettings {
    .tableBox {
      .select {
        color: #015293;
        font-size: 12px;
        cursor: pointer;
      }
      .tool_bar {
        overflow: hidden;
        padding-top: 18px;
        padding-bottom: 18px;
        font-size: 14px;
        color: #888;
        .el-form-item {
          margin-right: 0;
          margin-bottom: 0;
          .el-input__inner {
            width: 210px;
            height: 32px;
          }
          .el-input__inner {
            padding-left: 10px;
          }
          .middle {
            padding: 0 10px;
          }
          .searchBtn {
            width: 112px;
            height: 32px;
          }
        }
      }
      .el-table {
        min-height: 685px;
        &::before {
          height: 0;
        }
      }
    }
  }
  .attendanceDialog {
    .el-dialog__header {
      border-bottom: 1px solid #dcdfe6;
    }
    .el-dialog__body {
      padding-bottom: 10px;
      overflow: hidden;
      .el-form-item {
        margin-bottom: 20px;
      }
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner,
    .el-textarea__inner {
      width: 300px;
    }
    .el-input__inner {
      padding-left: 15px;
      width: 300px;
    }
    .searchBtn {
      width: 112px;
    }
  }
</style>
